export function isTokenExpired(token: string): boolean {
    const jwtToken = JSON.parse(window.atob(token.split('.')[1]));
    const expires = new Date(jwtToken.exp * 1000);
    return expires <= new Date();
}
